import { IonIcon, IonLabel, IonSegment, IonSegmentButton, SegmentValue } from '@ionic/react';
import { clipboardOutline, cogOutline, timeOutline } from 'ionicons/icons';
import React from 'react';
import { useAppSelector } from '../../store/hooks';

import { IonFooterWrapper } from './DashboardFooter.styles';

export enum DashboardSelectedTab {
  ClockingSummary = 'ClockingSummary',
  JobSearch = 'JobSearch',
  ClockingHistory = 'ClockingHistory',
}

interface IComponentProps {
  selectedTab: DashboardSelectedTab;
  handleChangeTab?: (tab: SegmentValue | undefined) => void;
  handleClickTab?: (e: React.MouseEvent<HTMLIonSegmentElement, MouseEvent>) => void;
}

const DashboardFooter: React.FC<IComponentProps> = ({ selectedTab, handleChangeTab, handleClickTab }) => {
  const { isDarkMode } = useAppSelector(state => state.settings);

  return (
    <IonFooterWrapper color="lightest">
      <IonSegment onIonChange={e => handleChangeTab && handleChangeTab(e.detail.value)} value={selectedTab} onClick={e => handleClickTab && handleClickTab((e))} className={isDarkMode ? 'segment segment-dark' : 'segment segment-light'}>
        <IonSegmentButton value={DashboardSelectedTab.ClockingSummary} className="dashboard-button">
          <IonIcon icon={cogOutline} />
          <IonLabel>Dashboard</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={DashboardSelectedTab.JobSearch} className="jobsearch-button">
          <IonIcon icon={clipboardOutline} />
          <IonLabel>Job Search</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={DashboardSelectedTab.ClockingHistory} className="history-button">
          <IonIcon icon={timeOutline} />
          <IonLabel>History</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </IonFooterWrapper>
  );
};

export default DashboardFooter;